import { type FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PRIMARY_NAV, isNavItemActive } from '@/navigation/navItems';
import { cn } from '@/utils/cn';

/**
 * MobileTabBar - bottom tab bar below sm. Icon plus a visible label; 44px+ targets.
 */
export const MobileTabBar: FC = () => {
  const { pathname } = useLocation();
  return (
    <nav aria-label="Main" className="sm:hidden fixed bottom-0 inset-x-0 z-40 bg-bg-secondary shadow-[0_-1px_0_0_var(--color-border-default)] pb-[env(safe-area-inset-bottom)]">
      <ul className="grid" style={{ gridTemplateColumns: `repeat(${PRIMARY_NAV.length}, minmax(0, 1fr))` }}>
        {PRIMARY_NAV.map((item) => {
          const active = isNavItemActive(item, pathname);
          const Icon = item.icon;
          return (
            <li key={item.id}>
              <Link
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 min-h-[var(--tab-bar-height)] text-xs',
                  active ? 'text-accent-primary' : 'text-text-secondary',
                )}
              >
                <Icon size={20} strokeWidth={1.5} aria-hidden="true" />
                <span>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
